//The Vue build version to load with the `import` command
//(runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import extend from './extend'
import * as filters from './filters'
import BackLink from './directives/back-link'
import titleMixin from './utils/title'
// 饿了么组件库
import eleUI from './components/ele'
import ZUI from './components/zui'
import CUI from './components/custom'
Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.mixin(titleMixin)
Vue.use(eleUI)
Vue.use(ZUI)
Vue.use(CUI)
Vue.use(extend)
//filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
//自定义指令
Vue.directive('back-link', BackLink);

new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: {
		App
	}
})



// WEBPACK FOOTER //
// ./src/main.js